<template>
    <div class="body">
        <div class="header" v-if="params.status != 3">
            <div class="inner">
                <!--<div class="task-name">{{params.name}}</div>-->
                <!--<div class="task-date">-->
                    <!--{{params.create_time_cn}}-->
                <!--</div>-->
                <!--<div class="task-question">-->
                    <!--{{params.question}}-->
                <!--</div>-->
                <div style="flex: 1;color: #aaa"><span @click="reviewTextStorage">保存</span></div>
                <div @click="commitWorkEvent" style="color:#2592db">提交</div>
            </div>
        </div>
        <div class="content">
            <div class="text-box">
                <textarea class="textArea" maxlength="10000" placeholder="请输入作业内容" :value="reviewText" @input='inputText' :disabled="params.status != 3?false:true"></textarea>
                <span class="wordwrap" v-if="params.status != 3">还可输入：{{number}} / {{maxNumber}}</span>
            </div>
            <div class="text-btn" v-if="res_type == ''">
                <div class="text-btn-li">
                    <!--<div class="text-btn-icon">-->
                        <!--<span class="iconfont iconcomiistupian"></span>-->
                    <!--</div>-->
                    <van-uploader class="text-btn-icon" :multiple="true" :after-read="chooseImage">
                        <span class="iconfont iconcomiistupian"></span>
                    </van-uploader>
                    <div class="text-btn-txt">图片</div>
                </div>
                <div class="text-btn-li" @click="chooseRecorder">
                    <div class="text-btn-icon">
                        <span class="iconfont iconyinpin"></span>
                    </div>
                    <div class="text-btn-txt">音频</div>
                </div>
            </div>

            <!-- 图片 -->
            <div class="task-img" v-if="res_type == 1">
                <!--<div class="task-img-title">请上传正方形的尺寸的、不超过5M的图片</div>-->
                <div class="task-img-list">
                    <div class="task-img-li" v-for="(item,index) in imgArray" :key="index">
                        <img @click="previewImg" class="pub-img" :src="item" :data-src="item" />
                        <span class="remove-img iconfont iconguanbi" @click.stop="btnRemoveImg" :data-index="index" v-if="params.status != 3"></span>
                    </div>

                    <van-uploader v-if="params.status != 3" :multiple="true" :after-read="chooseImage">
                        <div class="task-img-btn"></div>
                    </van-uploader>

                </div>
                <!--<div class="img-cnt-txt"><span v-if="params.status != 3">还可上传：</span>{{imgArray.length}} / {{maxImgNumber}}</div>-->
            </div>

            <!-- 音频 -->
            <div class="task-audio" v-if="res_type == 2">
                <div class="task-audio-btn" @click="chooseAudioPlay">
                    <span :class="'iconfont '+(isPlayingMusic?'iconbofang1':'iconbofang11')"></span>
                </div>
                <div class="task-audio-slider">
                    <van-slider v-model="int_time"
                                :max="int_max_time"
                                button-size="12px"
                                active-color="#327CE9"
                                inactive-color="#cccccc"
                                disabled />

                </div>
                <div class="task-audio-time">
                    {{max_time}}
                </div>
                <div class="task-audio-close">
                    <span class="iconfont iconguanbi" @click.stop="btnRemoveAudio" v-if="params.status != 3"></span>
                </div>
            </div>
        </div>

        <van-action-sheet v-model="visible" cancel-text="取消" :actions="actions" @cancel="handleCancel" @select="handleClickItem" />

        <van-uploader :after-read="chooseMp3File" accept="audio/*" id="chooseMp3File" ref="chooseMp3File" style="display: none"/>
        <!--<div class="edit-task" @click="commitWorkEvent" v-if="params.status != 3">-->
            <!--<span>提交作业</span>-->
        <!--</div>-->

        <div :class="'task-audio-mask '+(isOpenAudioMask?'i-as-mask-show':'')" @click="bindSetOpenAudioMaskFalse">
            <div :class="'task-audio-content '+(isOpenAudioMask?'i-as-show':'')" v-show="isOpenAudioMask" @click.stop="bindSetOpenAudioMaskTrue">
                <div class="icon" @click.stop="bindSetOpenAudioMaskFalse"><van-icon name="cross"  size="16" color="#aaaaaa"/></div>

                <div :class="'task-audio-recorder-time '+(recorder_max_time == 60000 ?'color-aaa':'')" v-if="recorder_time == 0">{{recorder_max_time == 60000 ?'最长不超过10分钟':recorder_max_time_txt}}</div>
                <div class="task-audio-recorder-time" v-if="recorder_time >0">{{recorder_time_txt}}</div>

                <div class="audio-task-btn" @click.stop="bindRecorderManagerStart" v-if="recorder_time == 0">
                    <span :class="'iconfont '+(isRecorderManager?'iconbofang1':'iconyinpin')"></span>
                </div>

                <div class="audio-task-btn" @click.stop="bindRecorderManagerPlay" v-if="recorder_time > 0">
                    <span :class="'iconfont '+(isRecorderManager?'iconbofang1':'iconbofang11')"></span>
                </div>

                <div class="audio-task-txt" v-if="recorder_time == 0">
                    点击按钮{{isRecorderManager?'结束':'开始'}}录制
                </div>
                <div class="audio-task-txt" v-if="recorder_time > 0 && is_audition">
                    点击按钮结束试听
                </div>
                <div class="audio-task-event" v-if="recorder_time > 0  && !is_audition">
                    <div class="audio-task-event-back" @click.stop="bindRecorderManagerBack">重录</div>
                    <div class="audio-task-event-save" @click.stop="bindRecorderManagerSave">确定</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Uploader,ImagePreview,Dialog,ActionSheet,Slider,Icon} from 'vant';
    import wx from 'weixin-js-sdk'
    var review_text_storage = 'reviewTextStorage_';
    var review_type_storage = 'reviewTypeStorage_';
    var review_datas_storage = 'reviewDatasStorage_';
    var audioInterval = null;
    var innerAudioContext = null; //音频播放
    var innerAudioRecorderContext = null; //录音播放
    var localId = null; // 微信音频id
    var duration_time_Interval=null;
    var duration_recorder=0;
    var is_start = false;
    export default {
        name: "edit",
        components:{
            [Uploader.name]:Uploader,
            [ActionSheet.name]:ActionSheet,
            [Slider.name]:Slider,
            [Icon.name]:Icon
        },
        data(){
            return{
                maxNumber:10000,//可输入最大字数
                number: 0,//已输入字数
                maxImgNumber:9,//可上传图片最大数量
                imgArray:[],
                reviewText:'',
                work_busy_id:'',
                status:0,
                myWork:[],
                params:[],
                res_type:'',
                res_datas:[],
                isPlayingMusic:false,//是否播放
                isOpenAudioMask:false,//是否打开录制弹层
                isRecorderManager:false,//是否开始录制
                recorder_time:0,//录制时长
                recorder_time_txt:'0:00',
                recorder_max_time:60000,//最大录制时长 单位 ms
                recorder_max_time_txt:'1:00',//文字形式
                is_audition:false,//是否在试听

                visible: false,
                actions: [
                    {
                        name: '录音',
                        value:'0'
                    },
                    {
                        name: '上传',
                        value:'1'
                    }
                ],
                max_time:'00:00',
                int_max_time:100,
                int_time:0
            }
        },
        beforeRouteLeave(to, from, next){
            if(to.name == 'curriculum/index') {
                to.meta.keepAlive = true;
            }
            next()
        },
        mounted() {
            const u = navigator.userAgent;
            const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

            if(isiOS && localStorage.getItem('ios_reload') != 1){

                localStorage.setItem('ios_reload',1)
                return location.reload();
            }

            localStorage.removeItem('ios_reload');
            this.util.hideOptionMenu();
            this.work_busy_id = this.util.getQueryStr('work_busy_id');
            var status = this.util.getQueryStr('status');
            var title = '写作业';
            if(status == 2){
                title = '编辑作业';
            }else if(status == 3){
                title = '查看作业';
            }
            this.$(document).attr('title',title);

            this.getDetail();
            // this.bindWeiXin();
        },
        methods:{
            bindWeiXin:function(){
                var _self=this;
                this.util.jweixin(function (wx) {
                    var _that=_self;
                    _self.util.wxShare(wx, {
                        title: _that.module_name,
                        desc: _that.module_name,
                        link: location.href,
                        imgUrl: _that.list[0].cover
                    });
                });
            },
            getDetail:function(){
                var _self=this;

                this.util.server.mini_work.get_detail({
                    data: {
                        work_busy_id:this.work_busy_id
                    },
                    callback: (res=>{
                        this.params = res.data;
                        _self.myWorkEvent();
                    })
                })
            },
            reviewTextStorage:function(){
                var _self=this;
                if(this.reviewText == ''){
                    return this.$router.back();
                }
                Dialog.confirm({
                    message: '确定要保留此编辑？',
                })
                .then((res) => {
                    // on confirm
                    localStorage.setItem(review_text_storage+_self.work_busy_id, _self.reviewText);
                    localStorage.setItem(review_type_storage+_self.work_busy_id, _self.res_type);
                    if(_self.res_type == 1){
                        localStorage.setItem(review_datas_storage+_self.work_busy_id, _self.imgArray);
                    }else{
                        localStorage.setItem(review_datas_storage+_self.work_busy_id, _self.res_datas);
                    }

                    this.$router.back();
                })
                .catch((res) => {
                    // on cancel
                    localStorage.setItem(review_text_storage+_self.work_busy_id,'');
                    localStorage.setItem(review_type_storage+_self.work_busy_id, '');
                    localStorage.setItem(review_datas_storage+_self.work_busy_id,'');
                    this.$router.back();
                });
            },
            myWorkEvent:function(){
                var _self=this;

                this.util.server.mini_work.my_work({
                    data:{
                        work_busy_id:this.work_busy_id
                    },
                    callback:(res=>{
                        this.myWork = res.data;
                        this.reviewText = res.data.content || '';
                        this.imgArray = res.data.images || [];
                        this.res_type = res.data.res_type;
                        this.res_datas = res.data.res_datas;

                        if(!res.data.content){
                            if(localStorage.getItem(review_type_storage+this.work_busy_id) == 1){
                                this.imgArray = localStorage.getItem(review_datas_storage+this.work_busy_id) || []
                            }else{
                                this.res_datas = localStorage.getItem(review_datas_storage+this.work_busy_id) || []
                            }
                            this.reviewText = localStorage.getItem(review_text_storage+this.work_busy_id) || '';
                            this.res_type = localStorage.getItem(review_type_storage+this.work_busy_id) || '';
                        }
                        this.number = this.reviewText.length;

                        if(this.res_type == 2){
                            this.chooseAudio();
                        }
                    })
                })
            },
            inputText:function(e){
                this.reviewText = e.target.value;//获取textarea的内容，
                this.number = e.target.value.length;//获取textarea的内容长度
            },
            //作业图片查看
            previewImg:function(e){
                var img = e.currentTarget.dataset.src;

                var startPosition = 0;
                for (var i =0;i<this.imgArray.length;i++){
                    if(this.imgArray[i] == img){
                        startPosition = i;
                        break;
                    }
                }

                ImagePreview({
                    images:this.imgArray,
                    startPosition:startPosition,
                    closeable: true
                });
            },
            //删除图片
            btnRemoveImg:function(e){
                var index= e.currentTarget.dataset.index;
                this.imgArray.splice(index,1);

                if(this.imgArray.length == 0){
                    this.res_type=0;
                }
            },
            //上传图片
            chooseImage:function(e){

                var _self = this;
                var imgs = this.imgArray;

                if(imgs.length >=9){
                    this.util.showToast({
                        message:'图片上传数量已最大'
                    });
                    return false;
                }

                if(e instanceof Array){
                    for (var i=0;i<e.length;i++){

                        if(imgs.length+i>=9){
                            break;
                        }

                        this.util.upfile({
                            file: e[i].file,
                            data: {},
                            callback: res => {

                                imgs.push(res.data.domain_url);
                                this.imgArray =imgs;
                                this.res_type=1;
                            }
                        });
                    }
                }else{
                    this.util.upfile({
                        file: e.file,
                        data: {},
                        callback: res => {

                            imgs.push(res.data.domain_url);
                            this.imgArray =imgs;
                            this.res_type=1;
                        }
                    });
                }
            },
            //保存作业
            commitWorkEvent:function(){
                if(this.reviewText==''){
                    return this.util.showToast({
                        message:'作业内容不能为空'
                    })
                }

                var _self=this;

                _self.util.server.mini_work.commit_work({
                    data:{
                        work_busy_id:this.work_busy_id,
                        content:this.reviewText,
                        images:this.imgArray,
                        res_type:this.res_type,
                        res_datas:this.res_datas
                    },
                    callback:(res=>{
                        _self.util.globalData.workEdit.set(1);
                        localStorage.removeItem(review_text_storage+_self.work_busy_id);
                        localStorage.removeItem(review_type_storage+_self.work_busy_id);
                        localStorage.removeItem(review_datas_storage+_self.work_busy_id);
                        _self.$router.back();
                    })
                })
            },
            //录音
            chooseRecorder:function(){

                var _self = this;

                var ua = navigator.userAgent.toLowerCase();
                var isWeixin = ua.indexOf('micromessenger') != -1;
                if(!isWeixin){
                   return this.util.showToast({
                        message:'请在手机端微信中操作'
                    })
                }

                //打开音频选项
                this.visible = true;
            },
            //取消音频
            handleCancel:function() {
                this.visible = false;
            },
            //音频选项
            handleClickItem:function (item) {
                this.visible = false;
                var index = item.value;
                var _self=this;

                if(index == 0){
                    _self.isOpenAudioMask=true;
                }else if(index == 1){
                    document.getElementById('chooseMp3File').click();
                    // this.$refs.chooseMp3File.click();
                }
            },
            //音频上传
            chooseMp3File:function (e) {
                var _self=this;
                this.util.upfile({
                    file: e.file,
                    data: {},
                    callback: res => {
                        _self.res_datas = [res.data.domain_url];
                        _self.res_type = 2;
                        _self.chooseAudio();
                    }
                });
            },
            //音频处理
            chooseAudio:function () {
                var _self=this;
                innerAudioContext = new Audio();
                innerAudioContext.src=this.res_datas[0];
                innerAudioContext.addEventListener('loadedmetadata', function() {

                    _self.max_time =_self.util.getTime(innerAudioContext.duration);
                    _self.int_max_time =innerAudioContext.duration;
                    _self.int_time = innerAudioContext.currentTime;
                })
            },
            //设置定时检测
            setAudioInterval(){
                audioInterval = setInterval(()=>{

                    this.int_time = innerAudioContext.currentTime;
                    if(innerAudioContext.ended){
                        //播放结束后重置数据
                        clearInterval(audioInterval);

                        this.isPlayingMusic=false;
                        innerAudioContext.currentTime=0;
                    }
                    if(innerAudioContext.paused){
                        this.isPlayingMusic=false
                    }else{
                        this.isPlayingMusic=true
                    }
                },500)
            },
            chooseAudioPlay(){
                clearInterval(audioInterval);
                if(this.isPlayingMusic){
                    this.isPlayingMusic=false
                    innerAudioContext.pause();
                }else{
                    this.isPlayingMusic=true
                    innerAudioContext.play();
                    innerAudioContext.currentTime=0;
                    this.setAudioInterval();
                }
            },
            //删除音频
            btnRemoveAudio:function(){
                clearInterval(audioInterval);
                innerAudioContext.pause();
                innerAudioContext=null;
                this.res_type='';
                this.res_datas=[];
                this.recorder_time=0;
                this.recorder_time_txt='';
                this.recorder_max_time=60000;
                this.recorder_max_time_txt='1:00';

                this.isPlayingMusic=false;
                this.max_time='00:00';
                this.int_max_time=100;
                this.int_time=0;
            },
            bindSetOpenAudioMaskFalse:function(){
                if(this.recorder_max_time != 60000){
                    return false;
                }
                this.isOpenAudioMask = false;
                this.res_datas = [];
                this.recorder_time = 0;
                this.recorder_time_txt = '';
                localId=null;
                duration_recorder=0;
            },
            bindSetOpenAudioMaskTrue:function(){
                this.isOpenAudioMask = true;
            },
            //开始录音
            bindRecorderManagerStart:function(){
                if(is_start){
                    return false;
                }
                is_start = true;
                var _self=this;

                if(_self.isRecorderManager){

                    wx.stopRecord({
                        success: function (res) {

                            _self.onVoiceRecordEnd(res);

                        }
                    });
                }else{
                    wx.startRecord({
                        success: function(){
                            is_start = false;
                            _self.isRecorderManager=true;
                            clearInterval(duration_time_Interval);
                            _self.setIntervalDurationTime();

                        },
                        cancel: function () {
                            _self.util.showToast({
                                message:'用户拒绝授权录音'
                            })
                        }
                    });

                }
            },
            //播放录音
            bindRecorderManagerPlay:function () {
                if(this.isRecorderManager){
                    wx.stopVoice({
                        localId: localId // 需要停止的音频的本地ID，由stopRecord接口获得
                    });
                    this.onVoicePlayEnd();
                }else{
                    this.isRecorderManager = true;
                    this.is_audition = true;
                    clearInterval(duration_time_Interval)
                    wx.playVoice({
                        localId: localId // 需要播放的音频的本地ID，由stopRecord接口获得
                    });
                    this.setIntervalRecorderTime();
                    this.bindRecorderManagerEvent();
                }
            },
            bindRecorderManagerEvent:function(){
                var _self = this;

                //监听录音自动停止接口
                wx.onVoiceRecordEnd({
                    // 录音时间超过一分钟没有停止的时候会执行 complete 回调
                    complete: function (res) {
                        _self.onVoiceRecordEnd(res);
                    }
                });

                //监听语音播放完毕接口
                wx.onVoicePlayEnd({
                    success: function (res) {
                        localId = res.localId; // 返回音频的本地ID
                        _self.onVoicePlayEnd();
                    }
                });
            },
            onVoiceRecordEnd(res){
                var _self = this;
                localId = res.localId;
                is_start = false;
                _self.isRecorderManager=false;
                clearInterval(duration_time_Interval);

                _self.recorder_max_time =60000;
                _self.recorder_max_time_txt='1:00';

                if(duration_recorder <=2000){
                    return _self.util.showToast({
                        message:'录制时长过短,请重新录制'
                    })
                }

                _self.recorder_time = duration_recorder;
                _self.recorder_time_txt = _self.util.getTime(duration_recorder/1000)
            },
            onVoicePlayEnd(){
                var _self = this;
                _self.isRecorderManager = false;
                _self.is_audition = false;
                clearInterval(duration_time_Interval)
                _self.recorder_time=duration_recorder;
                _self.recorder_time_txt =_self.util.getTime(duration_recorder/1000)
            },
            //重录
            bindRecorderManagerBack:function(){
                localId=null;
                this.recorder_time = 0;
                this.recorder_time_txt = '';
                this.res_datas = [];
                duration_recorder=0;
            },
            //确定录制
            bindRecorderManagerSave:function () {
                var _self=this;
                wx.uploadVoice({
                    localId: localId, // 需要上传的音频的本地ID，由stopRecord接口获得
                    isShowProgressTips: 1, // 默认为1，显示进度提示
                    success: function (res) {
                        var serverId = res.serverId; // 返回音频的服务器端ID

                        _self.util.server.api.get_wx_media({
                            data:{
                                server_id:serverId
                            },
                            callback:function (res) {

                                _self.res_datas=[res.data.url];
                                _self.res_type=2;
                                _self.isOpenAudioMask=false;

                                _self.chooseAudio();
                            }
                        })

                    }
                });
            },
            setIntervalDurationTime:function(){
                var _self=this;
                duration_time_Interval = setInterval(function () {

                    _self.recorder_max_time -=1000;
                    _self.recorder_max_time_txt = _self.util.getTime(_self.recorder_max_time/1000)
                    duration_recorder +=1000;

                },1000)
            },
            setIntervalRecorderTime:function(){
                var _self=this;
                duration_time_Interval = setInterval(function () {

                    _self.recorder_time -=1000;
                    _self.recorder_time_txt = _self.util.getTime(_self.recorder_time/1000)

                },1000)
            },
        }
    }
</script>

<style scoped>
    div{
        color: #3a3a3a;
    }
    .header,.content{
        padding: 10px;
        background-color: #fff;
    }
    .content{
        background-color: #f8f9fb;
    }
    .inner{
        position: relative;
        display: flex;
    }
    .inner .task-name{
        display: inline-block;
        width: 100%;
        box-sizing: border-box;
        font-weight: bold;
    }
    .inner .task-date{
        font-size: 12px;
        color: #aaa;
        padding-top: 5px;
        padding-bottom: 10px;
    }
    .text-box{
        background-color: #f8f9fb;
        width: 100%;
        padding: 10px;
        box-sizing: border-box;
    }
    .textArea{
        width: 100%;
        height: 180px;
    }
    .wordwrap,.img-cnt-txt{
        font-size: 12px;
        color: #aaa;
        width: 100%;
        text-align: right;
        display: inline-block;
    }
    .task-img-title{
        font-size: 12px;
        color: #aaaaaa;
        margin: 10px 0;
    }
    .task-img-list .task-img-btn{
        width: 24vw;
        height: 24vw;
        border: 1px solid #ccc;
        display: inline-block;
        position: relative;
    }
    .task-img-btn:after,.task-img-btn:before{
        background: #ccc;
        border-radius: 1px;
        content: '';
        height: 0;
        width: 0;
        position: absolute;
        left: 50%;
        top: 50%;
    }
    .task-img-btn:after {
        height: 20px;
        width: 2px;
        margin: -10px 0 0 -1px;
    }
    .task-img-btn:before {
        height: 2px;
        width: 20px;
        margin: -1px 0 0 -10px;
    }
    .task-img-li{
        display: inline-block;
        font-size: 0;
        margin-right: 15px;
        margin-bottom: 10px;
        position: relative;
    }
    .task-img-li .pub-img{
        width: 24vw;
        height: 24vw;
    }
    .task-img-li .remove-img{
        position: absolute;
        top: 0;
        right: 0;
        color: #f30;
        margin-top: -10px;
        margin-right: -10px;
        font-size: 20px;
    }
    .edit-task{
        position: fixed;
        bottom: 0;
        background-color: #fff;
        width: 100%;
        border-top: 1px solid #ccc;
        text-align: center;
        padding: 10px 0;
    }
    .text-btn{
        padding: 0 10px;
    }
    .text-btn-li{
        width: 40px;
        height: 80px;
        display: inline-block;
        text-align: center;
        margin-right: 25px;
    }
    .text-btn-li .text-btn-icon{
        background-color: #fff;
        width: 40px;
        height: 40px;
        border-radius: 5px;
        box-shadow: 1px 0 10px #eee;
    }
    .text-btn-li .text-btn-icon .iconfont{
        font-size: 23px;
        line-height: 40px;
    }
    .text-btn-li .text-btn-txt{
        width: 40px;
        height: 40px;
        line-height: 40px;
        font-size: 12px;
        color: #aaa;
    }
    .task-audio{
        min-width: 256px;
        background-color: #eee;
        margin: 0 10px;
        display: inline-block;
        position: relative;
    }
    .task-audio-btn{
        display: inline-block;
        vertical-align: middle;
        padding: 10px;
        padding-right: 5px;
    }
    .task-audio-btn .iconfont{
        font-size: 26px;
        color: #327CE9;
    }
    .task-audio-slider{
        display: inline-block;
        width: 170px;
        vertical-align: middle;
        margin: 10px;
    }
    .slider{
        margin: 10px;
    }
    .task-audio-time{
        display: inline-block;
        vertical-align: middle;
        font-size: 12px;
        padding-right: 10px;
    }
    .task-audio-close{
        position: absolute;
        top: 0;
        right: 0;
        color: #f30;
        margin-top: -10px;
        margin-right: -10px;
        font-size: 20px;
    }
    .task-audio-close .iconfont{
        font-size: 20px;
    }

    .task-audio-mask{
        position: fixed;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,.5);
        transition:all .2s ease-in-out;
        opacity:0;
        visibility:hidden;
        z-index:1000
    }
    .i-as-mask-show{
        opacity:1;
        visibility:visible
    }
    .task-audio-mask .task-audio-content{
        height: 40%;
        width: 100%;
        position: absolute;
        background-color: #ffffff;
        transform:translate3d(0,100%,0);
        transform-origin:center;
        transition:all .2s ease-in-out;
        visibility:hidden;
        z-index: 10;
        border-radius: 20px 20px 0 0;
        overflow: hidden;
        padding: 0 15px;
        box-sizing: border-box;
        bottom: 0;
        text-align: center;
    }
    .task-audio-mask .i-as-show{
        transform:translate3d(0,0,0);
        visibility:visible
    }
    .task-audio-content .icon{
        position: absolute;
        right: 10px;
        top: 10px;
    }
    .audio-task-btn{
        margin-top: 22%;
    }
    .audio-task-btn .iconfont{
        font-size: 60px;
        padding: 10px;
        background-color: #fff;
        box-shadow: 1px 0 10px #eee;
        border-radius: 50%;
        color: #327CE9;
    }
    .task-audio-recorder-time{
        position: absolute;
        width: 93%;
        text-align: center;
        top: 15%;
    }
    .audio-task-txt,.audio-task-event{
        margin-top: 30px;
    }
    .color-aaa{
        color: #aaaaaa;
    }
    .audio-task-event{
        display: flex;
    }
    .audio-task-event-back{
        flex: 1;
        padding: 15px 50px;
        background-color: #eee;
        color: #327CE9;
        border-radius: 5px;
        width: 48%;
        margin-right: 20px;
    }
    .audio-task-event-save{
        flex: 1;
        padding: 15px 50px;
        background-color: #327CE9;
        color: #fff;
        box-sizing: border-box;
        border-radius: 5px;
    }
    textarea{
        border: 0;
        background-color: transparent;
    }
    .text-btn-icon >>> .van-uploader__input-wrapper{
        width: 100%;
    }
</style>
